import {StyleSheet, css} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {DeepResearchChat} from 'llm/deep-research/DeepResearchChat';
import {CrumbLink, SplitBreadcrumbs} from 'nav/Breadcrumbs';
import ToggleDropdown from 'nav/ToggleDropdown';
import {PURPLE_DARK} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import ListingHeader from '../header/ListingHeader';

export interface DeepResearchSidepanelProps {
  isExpanded: boolean;
}

export function DeepResearchSidepanel(props: DeepResearchSidepanelProps): JSX.Element {
  return (
    <div className={classNames('sidepanel', css(styles.sidepanel))}>
      <div
        className={classNames(css(styles.sidepanelHeader), {
          [css(styles.sidepanelHeaderExpanded)]: props.isExpanded,
        })}
      >
        <ListingHeader
          isExpanded={props.isExpanded}
          crumbs={
            <SplitBreadcrumbs
              crumbs={[
                <div key="root" className={css(styles.breadcrumbsContainer)}>
                  <CrumbLink text="Deep Research" />
                  <BenchlingIcon icon="magic-wand" color={PURPLE_DARK} />
                </div>,
              ]}
            />
          }
          buttons={<ToggleDropdown className="u-mini-spacing-right" expanded={props.isExpanded} />}
          showShadow={true}
        />
      </div>
      <div className={css(styles.chatWrapper)}>
        <DeepResearchChat />
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  sidepanel: {
    display: 'flex',
    flexDirection: 'column',
  },
  sidepanelHeader: {
    padding: 0,
  },
  sidepanelHeaderExpanded: {
    padding: '16px 12px 0',
  },
  chatWrapper: {
    padding: '8px',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  breadcrumbsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
});

export default DeepResearchSidepanel;
